import * as React from "react";
import { TextField, NumberField } from "react-admin";
import { subResourceList } from "../_subresource";
import { FrDateField } from "../../components/FrDateField";

// GET /follow-up/programs/{programId}/entries (page 1-indexée + limit).
// Normalement consulté depuis la fiche programme → onglet « Entrées ».
export default {
  list: subResourceList({
    parentParam: "programId",
    parentLabel: "ID programme",
    children: [
      <FrDateField key="date" source="date" label="Date" />,
      <TextField key="value" source="value" label="Valeur" />,
      <NumberField locales="fr-FR" key="painScore" source="painScore" label="Douleur" />,
      <NumberField locales="fr-FR" key="moodScore" source="moodScore" label="Humeur" />,
      <TextField key="note" source="note" label="Note" />,
    ],
  }),
};
